import { Menu } from "@mui/icons-material"
import { IconButton, Stack, Typography } from "@mui/material"
import { useState } from "react"

import Button from "@components/button"
import PageHeader from "@components/page_header"
import { PRIMARY } from "@constants/colors"
import { showErrorToast } from "@utils/toast"

import { AccountPageContextProps } from "@contexts/account"
import { useAccountProfilePageContext } from "@contexts/account/profile"
import { updateUsers } from "@domain/users"
import useTranslate from "@hooks/use_translate"
import styles from "./styles"

export default function AccountProfilePageHeader() {
  const {
    translate,
    isLeftDrawerOpen,
    toggleIsLeftDrawerOpen,
    setProfileData,
    handleSubmit,
    me,
    isValid,
    isDirty,
    reset,
    setMe
  } = useAccountProfilePageContext()
  const [loading, setLoading] = useState<boolean>(false)

  const { changeLanguage } = useTranslate()

  async function onSubmit(data: AccountPageContextProps["profileData"]) {
    if (!me?._id || !setMe) {
      return
    }
    setLoading(true)
    const {
      isSuccess,
      errorMessage,
      data: responseData
    } = await updateUsers({
      _id: me._id,
      name: data.firstName,
      surname: data.lastName,
      email: data.email,
      phone: data.phone.value
    })
    if (!isSuccess || !responseData) {
      setLoading(false)
      showErrorToast(String(errorMessage))
      return
    }
    changeLanguage(data.language as "tr" | "en")
    setMe?.({
      ...me,
      name: data.firstName,
      surname: data.lastName,
      email: data.email,
      phone: data.phone.value
    })
    reset?.(data)
    setProfileData?.(data)
    setLoading(false)
  }

  return (
    <PageHeader sx={styles.content} isLeftPanelOpen={isLeftDrawerOpen}>
      <Stack direction={"row"} alignItems={"center"} columnGap={1} pl={1}>
        <IconButton
          onClick={toggleIsLeftDrawerOpen}
          disabled={!!isLeftDrawerOpen}
          disableRipple
          sx={{
            display: !!isLeftDrawerOpen ? "none" : "block",
            pl: 0,
            ":hover": {
              color: PRIMARY
            }
          }}
        >
          <Menu />
        </IconButton>
        <Typography variant="h6">{translate("profile")}</Typography>
      </Stack>
      <Button
        loading={loading}
        disabled={!isValid || !isDirty}
        onClick={handleSubmit?.(onSubmit)}
      >
        {translate("update")}
      </Button>
    </PageHeader>
  )
}
